import { BehaviorSubject } from 'rxjs';
// @Component({
// 	moduleId: module.id.toString(),
// 	template: '',
// 	styles: []
// })
var BaseComponent = /** @class */ (function () {
    function BaseComponent(router, route, logger, message, page, service) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.logger = logger;
        this.message = message;
        this.page = page;
        this.service = service;
        this.onConstruct();
        this.msg = new BehaviorSubject(this.message.getMessage());
        this.msg.subscribe(function (data) {
            _this.msgSnapshot = data;
            _this.onMsg(data);
        });
    }
    BaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.metaSubscription = this.page.meta().subscribe(function (meta) {
            _this.msg.next(_this.message.getMessage());
            _this.onInit(meta);
        });
    };
    BaseComponent.prototype.onConstruct = function () {
    };
    BaseComponent.prototype.onInit = function (meta) {
    };
    BaseComponent.prototype.onMsg = function (msg) {
    };
    BaseComponent.prototype.ngOnDestroy = function () {
        this.msg.unsubscribe();
        this.metaSubscription.unsubscribe();
    };
    return BaseComponent;
}());
export { BaseComponent };
//# sourceMappingURL=base.component.js.map